type MainTheme = {
  color: Colours;
  font: Fonts;
};

type Colours = {
  pink: string;
  lightPink: string;
  darkPink: string;
  grey: string;
  white: string;
  black: string;
  darkBlue: string;
  lightBlueOpacity: string;
  lightBlue: string;
};

type Fonts = {
  montserrat: string;
};

export const theme: MainTheme = {
  color: {
    pink: "#ed6d79",
    lightPink: "#fef3f4",
    darkPink: "#ab343f",
    grey: "#c7c7c7",
    white: "#ffffff",
    black: "#000000",
    darkBlue: "#668de5",
    lightBlueOpacity: "#eef2fc",
    lightBlue: "#eef2fc",
  },
  font: {
    montserrat: "Montserrat, sans-serif",
  },
};
